<template>
  <v-app
    :theme="isDarkTheme ? 'dark' : 'light'"
    :class="isDarkTheme ? 'dashboard-app-dark' : 'dashboard-app-light'"
  >
    <v-snackbar
      v-model="infoBanner.show"
      :timeout="5000"
      color="primary"
      location="top"
      rounded="xl"
      elevation="8"
    >
      <div class="d-flex align-center ga-2">
        <v-icon>mdi-information-outline</v-icon>{{ infoBanner.message }}
      </div>
    </v-snackbar>

    <v-main>
      <v-container fluid class="pa-5" style="max-width: 1600px; margin: 0 auto">
        <v-card
          class="mb-5 header-card"
          rounded="xl"
          :elevation="isDarkTheme ? 6 : 3"
        >
          <v-card-text class="py-4 px-6">
            <v-row align="center" no-gutters>
              <v-col>
                <div class="d-flex align-center ga-3">
                  <div
                    :class="isDarkTheme ? 'build-btn-dark' : 'build-btn-light'"
                    class="header-icon-wrap"
                  >
                    <v-icon size="30" color="white">mdi-phone-log</v-icon>
                  </div>
                  <div>
                    <div class="text-h5 font-weight-bold">
                      Enhanced Calls Dashboard
                    </div>
                    <div class="text-body-2 text-medium-emphasis">
                      Advanced analytics with filtering and export capabilities
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  :icon="
                    isDarkTheme ? 'mdi-weather-sunny' : 'mdi-weather-night'
                  "
                  @click="toggleTheme"
                  variant="tonal"
                  color="primary"
                  size="large"
                  rounded="lg"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mb-5" rounded="xl" :elevation="isDarkTheme ? 6 : 3">
          <v-card-text class="pa-6">
            <div class="d-flex align-center ga-3 mb-5">
              <v-icon color="primary" size="22">mdi-cloud-upload</v-icon>
              <span class="text-subtitle-1 font-weight-bold"
                >Upload Data File</span
              >
            </div>
            <v-row align="center">
              <v-col cols="12" md="9">
                <v-file-input
                  label="Choose Excel or CSV file (.xlsx, .xls, .csv)"
                  accept=".xlsx,.xls,.csv"
                  prepend-inner-icon="mdi-file-excel"
                  prepend-icon=""
                  variant="solo"
                  density="comfortable"
                  hide-details
                  :clearable="true"
                  style="border: 3px dotted; border-radius: 10px"
                  @change="handleExcelFileUpload"
                  color="primary"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  color="primary"
                  size="large"
                  rounded="xl"
                  block
                  prepend-icon="mdi-chart-bar"
                  :disabled="!fileUploaded"
                  @click="initializeDashboard"
                  :class="isDarkTheme ? 'build-btn-dark' : 'build-btn-light'"
                >
                  <span class="text-capitalize">Build Dashboard</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-expand-transition>
          <v-card
            v-if="isLoading"
            class="mb-5 loading-card"
            rounded="xl"
            :elevation="isDarkTheme ? 6 : 3"
          >
            <v-card-text class="py-8 d-flex flex-column align-center text-center">
              <v-progress-circular
                indeterminate
                color="primary"
                size="52"
                width="4"
                class="mb-4"
              />
              <div class="text-subtitle-1 font-weight-bold mb-4">
                {{ loadingMessage }}
              </div>
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="4"
                style="max-width: 320px; width: 100%"
              />
            </v-card-text>
          </v-card>
        </v-expand-transition>
        <v-expand-transition>
          <v-card
            v-if="showFilterCard"
            class="mb-5"
            rounded="xl"
            :elevation="isDarkTheme ? 6 : 3"
          >
            <v-card-text class="pa-6">
              <div class="d-flex align-center ga-3 mb-5">
                <v-icon color="primary" size="22">mdi-filter-variant</v-icon>
                <span class="text-subtitle-1 font-weight-bold"
                  >Filters &amp; Date Range</span
                >
              </div>
              <!-- <v-row align="end" class="gy-3">
                <v-col cols="12" sm="6" md="4" lg="2">
                  <div class="filter-label mb-1">Start Date</div>
                  <v-text-field
                    v-model="currentFilters.startDate"
                    type="date"
                    variant="outlined"
                    density="compact"
                    hide-details
                    color="primary"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <div class="filter-label mb-1">End Date</div>
                  <v-text-field
                    v-model="currentFilters.endDate"
                    type="date"
                    variant="outlined"
                    density="compact"
                    hide-details
                    color="primary"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <div class="filter-label mb-1">Team Lead</div>
                  <v-select
                    v-model="currentFilters.teamLeads"
                    :items="teamLeadOptions"
                    multiple
                    variant="outlined"
                    density="compact"
                    hide-details
                    chips
                    closable-chips
                    placeholder="All Team Leads"
                    color="primary"
                    @update:model-value="onTeamLeadChange"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <div class="filter-label mb-1">Client</div>
                  <v-select
                    v-model="currentFilters.clients"
                    :items="clientOptions"
                    multiple
                    variant="outlined"
                    density="compact"
                    hide-details
                    chips
                    closable-chips
                    placeholder="All Clients"
                    color="primary"
                    @update:model-value="onClientChange"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <div class="filter-label mb-1">Agent</div>
                  <v-select
                    v-model="currentFilters.agents"
                    :items="agentOptions"
                    multiple
                    variant="outlined"
                    density="compact"
                    hide-details
                    chips
                    closable-chips
                    placeholder="All Agents"
                    color="primary"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <div class="filter-label mb-1">Days for Average</div>
                  <v-text-field
                    v-model.number="averageDays"
                    type="number"
                    step="0.1"
                    min="0.1"
                    variant="outlined"
                    density="compact"
                    hide-details
                    placeholder="e.g. 11.5"
                    color="primary"
                  />
                </v-col>
                <v-col cols="12" sm="auto">
                  <v-btn
                    color="primary"
                    prepend-icon="mdi-sync"
                    @click="applyAllFilters"
                    rounded="xl"
                    size="large"
                    >Apply Filters</v-btn
                  >
                </v-col>
                <v-col cols="12" sm="auto">
                  <v-btn
                    variant="tonal"
                    prepend-icon="mdi-undo"
                    @click="clearAllFilters"
                    rounded="xl"
                    size="large"
                    >Reset</v-btn
                  >
                </v-col>
              </v-row> -->
              <v-row align="end" class="gy-3">
                <v-col cols="12" sm="6" md="2">
                  <div class="filter-label mb-1">Start Date</div>
                  <v-text-field
                    v-model="currentFilters.startDate"
                    type="date"
                    variant="outlined"
                    density="compact"
                    hide-details
                    color="primary"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <div class="filter-label mb-1">End Date</div>
                  <v-text-field
                    v-model="currentFilters.endDate"
                    type="date"
                    variant="outlined"
                    density="compact"
                    hide-details
                    color="primary"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="filter-label mb-1">Team Lead</div>
                  <v-select
                    v-model="currentFilters.teamLeads"
                    :items="teamLeadOptions"
                    multiple
                    variant="outlined"
                    density="compact"
                    hide-details
                    chips
                    closable-chips
                    placeholder="All Team Leads"
                    color="primary"
                    @update:model-value="onTeamLeadChange"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        title="Select All"
                        @click="toggleSelectALLTeamLeads"
                      >
                        <template v-slot:prepend>
                          <v-checkbox-btn
                            :color="
                              currentFilters.teamLeads.length > 0
                                ? 'primary'
                                : undefined
                            "
                            :indeterminate="
                              currentFilters.teamLeads.length > 0 &&
                              currentFilters.teamLeads.length !==
                                teamLeadOptions.length
                            "
                            :model-value="selectALLTeamLeads"
                          ></v-checkbox-btn>
                        </template>
                      </v-list-item>

                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip density="compact" v-if="index == 0">{{
                        item.title
                      }}</v-chip>
                      <span
                        v-if="index === 1"
                        class="text-caption align-self-center"
                      >
                        (+{{ currentFilters.teamLeads.length - 1 }})
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="filter-label mb-1">Client</div>
                  <v-select
                    v-model="currentFilters.clients"
                    :items="clientOptions"
                    multiple
                    variant="outlined"
                    density="compact"
                    hide-details
                    placeholder="All Clients"
                    color="primary"
                    @update:model-value="onClientChange"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        title="Select All"
                        @click="toggleSelectALLClients"
                      >
                        <template v-slot:prepend>
                          <v-checkbox-btn
                            :color="
                              currentFilters.clients.length > 0
                                ? 'primary'
                                : undefined
                            "
                            :indeterminate="
                              currentFilters.clients.length > 0 &&
                              currentFilters.clients.length !==
                                clientOptions.length
                            "
                            :model-value="selectALLClients"
                          ></v-checkbox-btn>
                        </template>
                      </v-list-item>

                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip density="compact" v-if="index == 0">{{
                        item.title
                      }}</v-chip>
                      <span
                        v-if="index === 1"
                        class="text-caption align-self-center"
                      >
                        (+{{ currentFilters.clients.length - 1 }})
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="filter-label mb-1">Agent</div>
                  <v-select
                    v-model="currentFilters.agents"
                    :items="agentOptions"
                    multiple
                    variant="outlined"
                    density="compact"
                    hide-details
                    placeholder="All Agents"
                    color="primary"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        title="Select All"
                        @click="toggleSelectALLAgents"
                      >
                        <template v-slot:prepend>
                          <v-checkbox-btn
                            :color="
                              currentFilters.agents.length > 0
                                ? 'primary'
                                : undefined
                            "
                            :indeterminate="
                              currentFilters.agents.length > 0 &&
                              currentFilters.agents.length !==
                                agentOptions.length
                            "
                            :model-value="selectALLAgents"
                          ></v-checkbox-btn>
                        </template>
                      </v-list-item>

                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip density="compact" v-if="index == 0">{{
                        item.title
                      }}</v-chip>
                      <span
                        v-if="index === 1"
                        class="text-grey text-body-small align-self-center"
                      >
                        (+{{ currentFilters.agents.length - 1 }})
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="filter-label mb-1">Days for Average</div>
                  <v-text-field
                    v-model.number="averageDays"
                    type="number"
                    step="0.1"
                    min="0.1"
                    variant="outlined"
                    density="compact"
                    hide-details
                    placeholder="e.g. 11.5"
                    color="primary"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-btn
                    :class="isDarkTheme ? 'build-btn-dark' : 'build-btn-light'"
                    prepend-icon="mdi-sync"
                    @click="applyAllFilters"
                    block
                    rounded="xl"
                    size="large"
                    >Apply Filters</v-btn
                  >
                </v-col>
                <v-col cols="12" sm="2">
                  <v-btn
                    variant="tonal"
                    color="primary"
                    prepend-icon="mdi-refresh"
                    @click="clearAllFilters"
                    rounded="xl"
                    block
                    size="large"
                    >Reset</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-expand-transition>
        <v-expand-transition>
          <v-card
            v-if="showFilterCard"
            rounded="xl"
            :elevation="isDarkTheme ? 6 : 3"
          >
            <v-tabs
              v-model="activeTab"
              color="primary"
              show-arrows
              bg-color="transparent"
              class="px-2"
            >
              <v-tab value="summary"
                ><v-icon class="mr-2" size="18">mdi-chart-pie</v-icon>Summary
                Dashboard</v-tab
              >
              <v-tab value="monthly"
                ><v-icon class="mr-2" size="18">mdi-calendar-month</v-icon
                >Monthly Disposition</v-tab
              >
              <v-tab value="charts"
                ><v-icon class="mr-2" size="18">mdi-chart-line</v-icon
                >Analytics</v-tab
              >
              <v-tab value="attempts"
                ><v-icon class="mr-2" size="18">mdi-format-list-numbered</v-icon
                >Total Attempts</v-tab
              >
              <v-tab value="disposition"
                ><v-icon class="mr-2" size="18">mdi-table</v-icon>Disposition
                Summary</v-tab
              >
            </v-tabs>
            <v-divider />

            <v-window v-model="activeTab">
              <v-window-item value="summary">
                <div class="pa-5">
                  <div
                    class="d-flex justify-space-between align-center flex-wrap ga-3 mb-4"
                  >
                    <div class="tab-section-title">
                      <v-icon color="primary" class="mr-2">mdi-chart-pie</v-icon
                      >Summary Overview
                    </div>
                    <div class="d-flex ga-2 flex-wrap">
                      <v-btn
                        size="small"
                        color="success"
                        prepend-icon="mdi-microsoft-excel"
                        @click="exportTabToFile('excel', 'summary')"
                        rounded="xl"
                        >Excel</v-btn
                      >
                      <v-btn
                        size="small"
                        variant="tonal"
                        prepend-icon="mdi-file-delimited"
                        @click="exportTabToFile('csv', 'summary')"
                        rounded="xl"
                        >CSV</v-btn
                      >
                      <v-btn
                        size="small"
                        variant="tonal"
                        prepend-icon="mdi-email"
                        @click="exportTabToFile('email', 'summary')"
                        rounded="xl"
                        >Email</v-btn
                      >
                    </div>
                  </div>

                  <v-data-table
                    class="hier-table"
                    :headers="summaryHeaders"
                    :items="summaryRows"
                    :items-per-page="-1"
                    fixed-header
                    height="62vh"
                    hide-default-footer
                    item-value="_id"
                    density="compact"
                    no-data-text="Upload a file and click Build Dashboard"
                  >
                    <template #item="{ item }">
                      <tr :class="getSummaryRowCssClass(item)">
                        <td
                          class="sticky-first"
                          :class="getSummaryIndentClass(item)"
                          :style="getSummaryFirstColumnStyle(item)"
                        >
                          <strong v-if="item._type === 'tl'">{{
                            item.name
                          }}</strong>
                          <span
                            v-else-if="item._type === 'cl'"
                            class="fw-600"
                            >{{ item.name }}</span
                          >
                          <span v-else>{{ item.name }}</span>
                        </td>
                        <td class="text-right num-cell">
                          <span
                            class="drill-link"
                            @click="
                              drilldownSummaryCell(
                                item._type,
                                item._val,
                                'total',
                              )
                            "
                            >{{ item.total }}</span
                          >
                        </td>
                        <td class="text-right num-cell">
                          <span
                            class="drill-link"
                            @click="
                              drilldownSummaryCell(
                                item._type,
                                item._val,
                                'unique',
                              )
                            "
                            >{{ item.unique }}</span
                          >
                        </td>
                        <template v-if="parsedAvgDays">
                          <td class="text-right num-cell">
                            {{ item.avgTotal }}
                          </td>
                          <td class="text-right num-cell">
                            {{ item.avgUnique }}
                          </td>
                        </template>
                        <td
                          v-for="h in summaryHours"
                          :key="'h' + h"
                          class="text-right num-cell"
                        >
                          <span
                            class="drill-link"
                            @click="
                              drilldownHourlyCell(item._type, item._val, h)
                            "
                            >{{ item["h_" + h] || 0 }}</span
                          >
                        </td>
                      </tr>
                    </template>
                    <template #tfoot>
                      <tr v-if="summaryRows.length" class="grand-tr">
                        <td
                          class="sticky-first grand-first"
                          :style="grandFirstBg"
                        >
                          <strong>GRAND TOTAL</strong>
                        </td>
                        <td class="text-right num-cell">
                          <strong>{{ summaryGrand.total }}</strong>
                        </td>
                        <td class="text-right num-cell">
                          <strong>{{ summaryGrand.unique }}</strong>
                        </td>
                        <template v-if="parsedAvgDays">
                          <td class="text-right num-cell">
                            <strong>{{ summaryGrand.avgTotal }}</strong>
                          </td>
                          <td class="text-right num-cell">
                            <strong>{{ summaryGrand.avgUnique }}</strong>
                          </td>
                        </template>
                        <td
                          v-for="h in summaryHours"
                          :key="'gh' + h"
                          class="text-right num-cell"
                        >
                          <strong>{{ summaryGrand["h_" + h] || 0 }}</strong>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-window-item>
              <v-window-item value="monthly">
                <div class="pa-5">
                  <div
                    class="d-flex justify-space-between align-center flex-wrap ga-3 mb-4"
                  >
                    <div class="tab-section-title">
                      <v-icon color="primary" class="mr-2"
                        >mdi-calendar-month</v-icon
                      >Monthly Disposition Analysis
                    </div>
                    <div class="d-flex ga-2 flex-wrap">
                      <v-btn
                        size="small"
                        color="success"
                        prepend-icon="mdi-microsoft-excel"
                        @click="exportTabToFile('excel', 'monthly')"
                        rounded="xl"
                        >Excel</v-btn
                      >
                      <v-btn
                        size="small"
                        variant="tonal"
                        prepend-icon="mdi-file-delimited"
                        @click="exportTabToFile('csv', 'monthly')"
                        rounded="xl"
                        >CSV</v-btn
                      >
                    </div>
                  </div>

                  <v-data-table
                    class="hier-table"
                    :headers="monthlyHeaders"
                    :items="monthlyRows"
                    :items-per-page="-1"
                    fixed-header
                    height="62vh"
                    hide-default-footer
                    item-value="_id"
                    density="compact"
                    no-data-text="Upload a file and click Build Dashboard"
                  >
                    <template #item="{ item }">
                      <tr
                        :class="item._type === 'month' ? 'tr-month' : 'tr-day'"
                      >
                        <td
                          class="sticky-first"
                          :class="item._type === 'day' ? 'pl-indent-1' : ''"
                          :style="item._type === 'month' ? monthBg : dayBg"
                        >
                          <strong v-if="item._type === 'month'">{{
                            item.name
                          }}</strong>
                          <em v-else class="text-medium-emphasis">{{
                            item.name
                          }}</em>
                        </td>
                        <td
                          v-for="d in monthlyDisps"
                          :key="'mv' + d"
                          class="text-right num-cell"
                          :class="item._type === 'day' ? 'drill-link' : ''"
                          @click="
                            item._type === 'day'
                              ? drilldownMonthlyDayCell(
                                  item._month,
                                  item._dk,
                                  d,
                                )
                              : null
                          "
                        >
                          <strong v-if="item._type === 'month'">{{
                            item[generateSafeKey(d)] || 0
                          }}</strong>
                          <span v-else>{{
                            item[generateSafeKey(d)] || 0
                          }}</span>
                        </td>
                        <td class="text-right num-cell">
                          <strong v-if="item._type === 'month'">{{
                            item._tot
                          }}</strong>
                          <span v-else>{{ item._tot }}</span>
                        </td>
                      </tr>
                    </template>
                    <template #tfoot>
                      <tr v-if="monthlyRows.length" class="grand-tr">
                        <td
                          class="sticky-first grand-first"
                          :style="grandFirstBg"
                        >
                          <strong>GRAND TOTAL</strong>
                        </td>
                        <td
                          v-for="d in monthlyDisps"
                          :key="'mg' + d"
                          class="text-right num-cell"
                        >
                          <strong>{{
                            monthlyGrand[generateSafeKey(d)] || 0
                          }}</strong>
                        </td>
                        <td class="text-right num-cell">
                          <strong>{{ monthlyGrand._tot }}</strong>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-window-item>
              <v-window-item value="charts">
                <div class="pa-5">
                  <div
                    class="d-flex justify-space-between align-center flex-wrap ga-3 mb-4"
                  >
                    <div class="tab-section-title">
                      <v-icon color="primary" class="mr-2"
                        >mdi-chart-line</v-icon
                      >Analytics &amp; Visualizations
                    </div>
                    <div class="d-flex align-center ga-3">
                      <div class="filter-label">Chart Style:</div>
                      <v-select
                        v-model="chartStyle"
                        :items="chartStyleOptions"
                        variant="outlined"
                        density="compact"
                        hide-details
                        style="min-width: 160px"
                        color="primary"
                      />
                    </div>
                  </div>
                  <v-card variant="tonal" class="pa-4 mb-5" rounded="lg">
                    <div class="filter-label mb-3">
                      Select Charts to Display
                    </div>
                    <div class="d-flex flex-wrap ga-3">
                      <v-checkbox
                        v-model="selectedCharts.disposition"
                        label="Disposition Distribution"
                        density="compact"
                        hide-details
                        color="primary"
                      />
                      <v-checkbox
                        v-model="selectedCharts.teamPerformance"
                        label="Team Performance"
                        density="compact"
                        hide-details
                        color="primary"
                      />
                      <v-checkbox
                        v-model="selectedCharts.dailyTrend"
                        label="Daily Trends"
                        density="compact"
                        hide-details
                        color="primary"
                      />
                      <v-checkbox
                        v-model="selectedCharts.callVolume"
                        label="Call Volume"
                        density="compact"
                        hide-details
                        color="primary"
                      />
                      <v-checkbox
                        v-model="selectedCharts.dispositionSnapshot"
                        label="Disposition Snapshot"
                        density="compact"
                        hide-details
                        color="primary"
                      />
                      <v-checkbox
                        v-model="selectedCharts.balanceSnapshot"
                        label="Balance Snapshot"
                        density="compact"
                        hide-details
                        color="primary"
                      />
                    </div>
                  </v-card>
                  <v-row>
                    <v-col v-show="selectedCharts.disposition" cols="12" md="6">
                      <v-card
                        class="chart-card pa-4"
                        rounded="xl"
                        :elevation="isDarkTheme ? 4 : 2"
                      >
                        <apexchart
                          :key="'disp-' + chartRerenderTriggerKey"
                          type="donut"
                          height="380"
                          :options="dispositionChart.options"
                          :series="dispositionChart.series"
                        />
                      </v-card>
                    </v-col>
                    <v-col
                      v-show="selectedCharts.teamPerformance"
                      cols="12"
                      md="6"
                    >
                      <v-card
                        class="chart-card pa-4"
                        rounded="xl"
                        :elevation="isDarkTheme ? 4 : 2"
                      >
                        <apexchart
                          :key="'disp-' + chartRerenderTriggerKey"
                          type="bar"
                          height="380"
                          :options="teamPerformanceChart.options"
                          :series="teamPerformanceChart.series"
                        />
                      </v-card>
                    </v-col>
                    <v-col v-show="selectedCharts.dailyTrend" cols="12" md="6">
                      <v-card
                        class="chart-card pa-4"
                        rounded="xl"
                        :elevation="isDarkTheme ? 4 : 2"
                      >
                        <apexchart
                          :key="'disp-' + chartRerenderTriggerKey"
                          type="line"
                          height="380"
                          :options="dailyTrendChart.options"
                          :series="dailyTrendChart.series"
                        />
                      </v-card>
                    </v-col>
                    <v-col v-show="selectedCharts.callVolume" cols="12" md="6">
                      <v-card
                        class="chart-card pa-4"
                        rounded="xl"
                        :elevation="isDarkTheme ? 4 : 2"
                      >
                        <apexchart
                          :key="'disp-' + chartRerenderTriggerKey"
                          type="bar"
                          height="380"
                          :options="callVolumeChart.options"
                          :series="callVolumeChart.series"
                        />
                      </v-card>
                    </v-col>
                    <v-col
                      v-show="selectedCharts.dispositionSnapshot"
                      cols="12"
                      md="6"
                    >
                      <v-card
                        class="chart-card pa-4"
                        rounded="xl"
                        :elevation="isDarkTheme ? 4 : 2"
                      >
                        <apexchart
                          :key="'disp-' + chartRerenderTriggerKey"
                          type="bar"
                          height="380"
                          :options="dispositionSnapshotChart.options"
                          :series="dispositionSnapshotChart.series"
                        />
                      </v-card>
                    </v-col>
                    <v-col
                      v-show="selectedCharts.balanceSnapshot"
                      cols="12"
                      md="6"
                    >
                      <v-card
                        class="chart-card pa-4"
                        rounded="xl"
                        :elevation="isDarkTheme ? 4 : 2"
                      >
                        <template v-if="hasBalanceData">
                          <apexchart
                            :key="'disp-' + chartRerenderTriggerKey"
                            type="bar"
                            height="380"
                            :options="balanceSnapshotChart.options"
                            :series="balanceSnapshotChart.series"
                          />
                        </template>
                        <template v-else>
                          <div
                            class="d-flex align-center justify-center"
                            style="height: 395px; color: #888"
                          >
                            <div class="text-center">
                              <v-icon size="48" class="mb-2" color="grey"
                                >mdi-chart-bar</v-icon
                              >
                              <div>Current_Balance data not available</div>
                            </div>
                          </div>
                        </template>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-window-item>
              <v-window-item value="attempts">
                <div class="pa-5">
                  <div
                    class="d-flex justify-space-between align-center flex-wrap ga-3 mb-4"
                  >
                    <div class="tab-section-title">
                      <v-icon color="primary" class="mr-2"
                        >mdi-format-list-numbered</v-icon
                      >Total Attempts
                    </div>
                    <div class="d-flex ga-2 flex-wrap">
                      <v-btn
                        size="small"
                        color="success"
                        prepend-icon="mdi-microsoft-excel"
                        @click="exportTabToFile('excel', 'attempts')"
                        rounded="xl"
                        >Excel</v-btn
                      >
                      <v-btn
                        size="small"
                        variant="tonal"
                        prepend-icon="mdi-file-delimited"
                        @click="exportTabToFile('csv', 'attempts')"
                        rounded="xl"
                        >CSV</v-btn
                      >
                    </div>
                  </div>

                  <v-alert
                    v-if="!attemptsHasData && filteredData.length"
                    type="info"
                    variant="tonal"
                    rounded="xl"
                    class="mb-4"
                  >
                    "No of attempts" column not found. This tab requires a "No
                    of attempts" column in your Excel file.
                  </v-alert>

                  <v-data-table
                    v-if="attemptsHasData || !filteredData.length"
                    class="hier-table"
                    :headers="attemptsHeaders"
                    :items="attemptsRows"
                    :items-per-page="-1"
                    fixed-header
                    height="62vh"
                    hide-default-footer
                    item-value="_id"
                    density="compact"
                    no-data-text="Upload a file and click Build Dashboard"
                  >
                    <template #item="{ item }">
                      <tr :class="getAttemptsRowCssClass(item)">
                        <td
                          class="sticky-first"
                          :class="getAttemptsIndentClass(item)"
                          :style="getAttemptsFirstColumnStyle(item)"
                        >
                          <strong v-if="item._type === 'cl'">{{
                            item.name
                          }}</strong>
                          <span v-else>{{ item.name }}</span>
                        </td>
                        <td
                          v-for="n in attemptsKeys"
                          :key="'av' + n"
                          class="text-right num-cell"
                        >
                          <span
                            class="drill-link"
                            @click="drilldownAttemptCell(item, n)"
                          >
                            <strong v-if="item._type === 'cl'">{{
                              item["a_" + n] || 0
                            }}</strong>
                            <span v-else>{{ item["a_" + n] || 0 }}</span>
                          </span>
                        </td>
                        <td class="text-right num-cell">
                          <span
                            class="drill-link"
                            @click="drilldownAttemptTotalCell(item)"
                          >
                            <strong v-if="item._type === 'cl'">{{
                              item._tot
                            }}</strong>
                            <span v-else>{{ item._tot }}</span>
                          </span>
                        </td>
                      </tr>
                    </template>
                    <template #tfoot>
                      <tr v-if="attemptsRows.length" class="grand-tr">
                        <td
                          class="sticky-first grand-first"
                          :style="grandFirstBg"
                        >
                          <strong>GRAND TOTAL</strong>
                        </td>
                        <td
                          v-for="n in attemptsKeys"
                          :key="'ag' + n"
                          class="text-right num-cell"
                        >
                          <strong>{{ attemptsGrand["a_" + n] || 0 }}</strong>
                        </td>
                        <td class="text-right num-cell">
                          <strong>{{ attemptsGrand._tot }}</strong>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-window-item>
              <v-window-item value="disposition">
                <div class="pa-5">
                  <div
                    class="d-flex justify-space-between align-center flex-wrap ga-3 mb-4"
                  >
                    <div class="tab-section-title">
                      <v-icon color="primary" class="mr-2">mdi-table</v-icon
                      >Disposition Category Summary
                    </div>
                    <div class="d-flex ga-2 flex-wrap">
                      <v-btn
                        size="small"
                        color="success"
                        prepend-icon="mdi-microsoft-excel"
                        @click="exportTabToFile('excel', 'disposition')"
                        rounded="xl"
                        >Excel</v-btn
                      >
                      <v-btn
                        size="small"
                        variant="tonal"
                        prepend-icon="mdi-file-delimited"
                        @click="exportTabToFile('csv', 'disposition')"
                        rounded="xl"
                        >CSV</v-btn
                      >
                    </div>
                  </div>

                  <v-data-table
                    class="hier-table"
                    :headers="dispHeaders"
                    :items="dispRows"
                    :items-per-page="-1"
                    fixed-header
                    height="62vh"
                    hide-default-footer
                    item-value="_id"
                    density="compact"
                    no-data-text="Upload a file and click Build Dashboard"
                  >
                    <template #item="{ item }">
                      <tr class="tr-client">
                        <td class="sticky-first" :style="clientBg">
                          {{ item.name }}
                        </td>
                        <td
                          v-for="c in dispClients"
                          :key="'dv' + c"
                          class="text-right num-cell drill-link"
                          @click="drilldownDispositionClientCell(item._disp, c)"
                        >
                          {{ item[generateSafeKey(c)] || 0 }}
                        </td>
                        <td class="text-right num-cell">
                          <strong>{{ item._tot }}</strong>
                        </td>
                      </tr>
                    </template>
                    <template #tfoot>
                      <tr v-if="dispRows.length" class="grand-tr">
                        <td
                          class="sticky-first grand-first"
                          :style="grandFirstBg"
                        >
                          <strong>GRAND TOTAL</strong>
                        </td>
                        <td
                          v-for="c in dispClients"
                          :key="'dg' + c"
                          class="text-right num-cell"
                        >
                          <span
                            class="drill-link"
                            @click="drilldownDispositionClientCell('ALL', c)"
                            ><strong>{{
                              dispGrand[generateSafeKey(c)] || 0
                            }}</strong></span
                          >
                        </td>
                        <td class="text-right num-cell">
                          <strong>{{ dispGrand._tot }}</strong>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </v-window-item>
            </v-window>
          </v-card>
        </v-expand-transition>
      </v-container>
    </v-main>
    <v-dialog v-model="modal.open" max-width="1200" scrollable>
      <v-card rounded="xl">
        <v-card-title class="pa-5 d-flex justify-space-between align-center">
          <span class="text-h6 font-weight-bold">{{ modal.title }}</span>
          <div class="d-flex ga-2 align-center">
            <v-btn
              color="success"
              size="small"
              prepend-icon="mdi-download"
              @click="exportModalToExcel"
              rounded="xl"
              >Export</v-btn
            >
            <v-btn
              icon="mdi-close"
              variant="text"
              @click="modal.open = false"
            />
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <div
            v-if="!modal.items.length"
            class="text-center pa-12 text-medium-emphasis"
          >
            No data for this selection
          </div>
          <v-data-table
            v-else
            class="modal-vdt"
            :headers="modal.headers"
            :items="modal.items"
            :items-per-page="25"
            :items-per-page-options="[10, 25, 50, 100, -1]"
            fixed-header
            height="62vh"
            item-value="_rowIdx"
            :search="modal.search"
            density="compact"
          >
            <template #top>
              <div class="pa-3 d-flex align-center ga-3">
                <v-text-field
                  v-model="modal.search"
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Search records..."
                  variant="outlined"
                  density="compact"
                  hide-details
                  clearable
                  style="max-width: 300px"
                  color="primary"
                />
                <v-spacer />
                <span class="text-body-2 text-medium-emphasis"
                  >{{ modal.items.length }} records</span
                >
              </div>
              <v-divider />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import * as XLSX from "xlsx";
import VueApexCharts from "vue3-apexcharts";

export default {
  components: { apexchart: VueApexCharts },

  data() {
    return {
      rawData: [],
      filteredData: [],
      isDarkTheme: false,
      isLoading: false,
      selectALLAgents: false,
      selectALLClients: false,
      selectALLTeamLeads: false,
      loadingMessage: "Processing...",
      showFilterCard: false,
      fileUploaded: false,
      activeTab: "summary",
      averageDays: null,
      currentFilters: {
        startDate: null,
        endDate: null,
        teamLeads: [],
        clients: [],
        agents: [],
      },
      teamLeadOptions: [],
      clientOptions: [],
      agentOptions: [],
      infoBanner: { show: false, message: "" },
      modal: {
        open: false,
        title: "",
        rows: [],
        cols: [],
        headers: [],
        items: [],
        search: "",
      },
      hasBalanceData: false,
      chartRerenderTriggerKey: 0,
      chartStyleOptions: [
        { title: "Wave Line", value: "wave" },
        { title: "Trend Line", value: "trend" },
        { title: "Smooth Line", value: "smooth" },
        { title: "Stepped Line", value: "stepped" },
      ],
      chartStyle: "wave",
      selectedCharts: {
        disposition: true,
        teamPerformance: true,
        dailyTrend: true,
        callVolume: true,
        dispositionSnapshot: true,
        balanceSnapshot: true,
      },
      dispositionChart: {
        series: [0],
        options: { chart: { type: "donut" }, labels: ["No data"] },
      },
      teamPerformanceChart: {
        series: [{ name: "Total Calls", data: [0] }],
        options: { chart: { type: "bar" }, xaxis: { categories: ["No data"] } },
      },
      dailyTrendChart: {
        series: [{ name: "Calls per Day", data: [0] }],
        options: {
          chart: { type: "line" },
          xaxis: { categories: ["No data"] },
        },
      },
      callVolumeChart: {
        series: [{ name: "Total Calls", data: [0] }],
        options: { chart: { type: "bar" }, xaxis: { categories: ["No data"] } },
      },
      dispositionSnapshotChart: {
        series: [{ name: "Call Count", data: [0] }],
        options: { chart: { type: "bar" }, xaxis: { categories: ["No data"] } },
      },
      balanceSnapshotChart: {
        series: [{ name: "Customer Count", data: [0] }],
        options: { chart: { type: "bar" }, xaxis: { categories: ["No data"] } },
      },
      summaryRows: [],
      summaryGrand: {},
      summaryHours: [],
      summaryHeaders: [],
      monthlyRows: [],
      monthlyGrand: {},
      monthlyDisps: [],
      monthlyHeaders: [],
      attemptsRows: [],
      attemptsGrand: {},
      attemptsKeys: [],
      attemptsHeaders: [],
      attemptsHasData: false,
      dispRows: [],
      dispGrand: {},
      dispClients: [],
      dispHeaders: [],
    };
  },

  computed: {
    parsedAvgDays() {
      return this.averageDays ? parseFloat(this.averageDays) : null;
    },
    grandFirstBg() {
      return {
        background: this.isDarkTheme ? "#1e2a40" : "#e8ecff",
        position: "sticky",
        left: 0,
        zIndex: 4,
      };
    },
    monthBg() {
      return {
        background: this.isDarkTheme
          ? "rgba(67,97,238,0.18)"
          : "rgba(67,97,238,0.1)",
        position: "sticky",
        left: 0,
        zIndex: 3,
      };
    },
    dayBg() {
      return {
        background: this.isDarkTheme ? "#1a2235" : "#fff",
        position: "sticky",
        left: 0,
        zIndex: 3,
      };
    },
    clientBg() {
      return {
        background: this.isDarkTheme
          ? "rgba(76,201,240,0.1)"
          : "rgba(76,201,240,0.06)",
        position: "sticky",
        left: 0,
        zIndex: 3,
      };
    },
  },

  mounted() {
    const saved = localStorage.getItem("dash_theme");
    if (saved === "dark") this.isDarkTheme = true;
  },

  watch: {
    isDarkTheme() {
      if (this.filteredData.length) this.generateAllCharts();
    },
    "currentFilters.clients.length"(val) {
      if (val == this.clientOptions.length) {
        this.selectALLClients = true;
      } else {
        this.selectALLClients = false;
      }
    },
    "currentFilters.teamLeads.length"(val) {
      if (val == this.teamLeadOptions.length) {
        this.selectALLTeamLeads = true;
      } else {
        this.selectALLTeamLeads = false;
      }
    },
    "currentFilters.agents.length"(val) {
      if (val == this.agentOptions.length) {
        this.selectALLAgents = true;
      } else {
        this.selectALLAgents = false;
      }
    },
  },

  methods: {
    generateSafeKey(name) {
      return "k_" + String(name).replace(/[^a-zA-Z0-9]/g, "_");
    },
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      localStorage.setItem("dash_theme", this.isDarkTheme ? "dark" : "light");
    },
    toggleSelectALLAgents() {
      this.selectALLAgents = !this.selectALLAgents;
      if (this.selectALLAgents) {
        this.currentFilters.agents = this.agentOptions;
      } else {
        this.currentFilters.agents = [];
      }
    },

    toggleSelectALLClients() {
      this.selectALLClients = !this.selectALLClients;
      if (this.selectALLClients) {
        this.currentFilters.clients = this.clientOptions;
      } else {
        this.currentFilters.clients = [];
      }
    },

    toggleSelectALLTeamLeads() {
      this.selectALLTeamLeads = !this.selectALLTeamLeads;
      if (this.selectALLTeamLeads) {
        this.currentFilters.teamLeads = this.teamLeadOptions;
      } else {
        this.currentFilters.teamLeads = [];
      }
    },

    showInfoBanner(msg) {
      this.infoBanner.message = msg;
      this.infoBanner.show = true;
    },

    convertToProperCase(s) {
      if (!s || typeof s !== "string") return s;
      return s
        .toLowerCase()
        .replace(/[._]/g, " ")
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
        .replace(/\s+/g, " ")
        .trim();
    },

    extractUniqueCustomerIdentifier(callRecord) {
      // Priority: Customer_ID → Phone_Number → Number → Customer_name
      // Returns a prefixed string like "CID:001", "PH:0501234567", etc.
      if (!callRecord) return null;
      const customerId =
        callRecord.Customer_ID != null
          ? String(callRecord.Customer_ID).trim()
          : "";
      const phoneNumber =
        callRecord.Phone_Number != null
          ? String(callRecord.Phone_Number).trim()
          : "";
      const numberField =
        callRecord.Number != null ? String(callRecord.Number).trim() : "";
      const customerName =
        callRecord.Customer_name != null
          ? String(callRecord.Customer_name).trim()
          : "";
      return customerId
        ? "CID:" + customerId
        : phoneNumber
        ? "PH:" + phoneNumber
        : numberField
        ? "NUM:" + numberField
        : customerName
        ? "NAME:" + customerName
        : null;
    },

    formatCellValue(row, col) {
      let v = row[col];
      if (col === "Date" && v instanceof Date) return v.toLocaleString();
      return v != null ? v : "";
    },

    // Summary row styling
    getSummaryRowCssClass(r) {
      if (r._type === "tl") return "tr-tl";
      if (r._type === "cl") return "tr-cl";
      if (r._type === "ag") return r._even ? "tr-ag-even" : "";
      return "";
    },
    getSummaryIndentClass(r) {
      if (r._type === "cl" && r._showTL) return "pl-indent-1";
      if (r._type === "ag") {
        if (r._showTL && r._showCL) return "pl-indent-2";
        if (r._showTL || r._showCL) return "pl-indent-1";
      }
      return "";
    },
    getSummaryFirstColumnStyle(r) {
      const d = this.isDarkTheme;
      const map = {
        tl: d ? "rgba(67,97,238,0.2)" : "rgba(67,97,238,0.07)",
        cl: d ? "rgba(76,201,240,0.1)" : "rgba(76,201,240,0.06)",
        ag: r._even
          ? d
            ? "rgba(102,126,234,0.08)"
            : "rgba(102,126,234,0.04)"
          : d
          ? "#1a2235"
          : "#fff",
      };
      return {
        background: map[r._type] || (d ? "#1a2235" : "#fff"),
        position: "sticky",
        left: 0,
        zIndex: 3,
      };
    },

    // Attempts row styling
    getAttemptsRowCssClass(tableRow) {
      if (tableRow._type === "cl") return "tr-tl"; // Client row — top level
      if (tableRow._type === "ag_att") return "tr-cl"; // Agent row — second level
      if (tableRow._type === "disp") return "tr-ag-even"; // Disposition row — third level
      return "";
    },
    getAttemptsIndentClass(tableRow) {
      if (tableRow._type === "ag_att") return "pl-indent-1"; // Agent indented once
      if (tableRow._type === "disp") return "pl-indent-2"; // Disposition indented twice
      return "";
    },
    getAttemptsFirstColumnStyle(tableRow) {
      const isDark = this.isDarkTheme;
      const backgroundColorByRowType = {
        cl: isDark ? "rgba(67,97,238,0.2)" : "rgba(67,97,238,0.07)",
        ag_att: isDark ? "rgba(76,201,240,0.1)" : "rgba(76,201,240,0.06)",
        disp: isDark ? "rgba(102,126,234,0.08)" : "rgba(102,126,234,0.04)",
      };
      return {
        background:
          backgroundColorByRowType[tableRow._type] ||
          (isDark ? "#1a2235" : "#fff"),
        position: "sticky",
        left: 0,
        zIndex: 3,
      };
    },

    // File Upload
    handleExcelFileUpload(uploadEvent) {
      // Accept either a DOM input event or a raw File object (drag-and-drop)
      const uploadedFile =
        uploadEvent?.target?.files?.[0] ||
        (uploadEvent instanceof File ? uploadEvent : null);
      if (!uploadedFile) return;

      const fileReader = new FileReader();

      fileReader.onload = (readerEvent) => {
        try {
          // Parse Excel binary into a workbook object
          const workbook = XLSX.read(
            new Uint8Array(readerEvent.target.result),
            { type: "array" },
          );
          let parsedRows = XLSX.utils.sheet_to_json(
            workbook.Sheets[workbook.SheetNames[0]],
          );

          if (!parsedRows.length) {
            alert("The uploaded file appears to be empty.");
            return;
          }

          // ── Normalize column names to internal standard keys
          parsedRows = parsedRows.map((rawRow) => {
            const normalizedRow = {};

            Object.keys(rawRow).forEach((originalColumnName) => {
              let normalizedColumnName = originalColumnName;

              // Map display names → internal keys
              if (originalColumnName === "Team Lead")
                normalizedColumnName = "Team_Lead";
              if (originalColumnName === "Client Name")
                normalizedColumnName = "Client_name";
              if (
                ["Called by", "Called By", "Agent_Email"].includes(
                  originalColumnName,
                )
              )
                normalizedColumnName = "Agent_email";
              if (
                [
                  "Called On",
                  "Last Updated On",
                  "Called on",
                  "Last updated on",
                  "Last update on",
                  "Called_On",
                ].includes(originalColumnName)
              )
                normalizedColumnName = "Date";
              if (["Last Updated", "Last_Updated"].includes(originalColumnName))
                normalizedColumnName = "Last_Updated";
              if (originalColumnName === "Disposition Category")
                normalizedColumnName = "Disposition_category";
              if (originalColumnName === "Disposition Code")
                normalizedColumnName = "Disposition_code";
              if (originalColumnName === "Campaign Name")
                normalizedColumnName = "Campaign_name";

              let cellValue = rawRow[originalColumnName];

              // Strip company email domain and apply proper casing for name fields
              if (
                normalizedColumnName === "Agent_email" &&
                typeof cellValue === "string"
              )
                cellValue = this.convertToProperCase(
                  cellValue.replace(/@altamayez\.ae/g, "").trim(),
                );
              if (
                normalizedColumnName === "Team_Lead" &&
                typeof cellValue === "string"
              )
                cellValue = this.convertToProperCase(
                  cellValue.replace(/@altamayez\.ae/g, "").trim(),
                );

              normalizedRow[normalizedColumnName] = cellValue;
            });

            return normalizedRow;
          });

          // ── Handle missing column fallbacks
          const availableColumns = Object.keys(parsedRows[0] || {});

          if (!availableColumns.includes("Team_Lead"))
            parsedRows = parsedRows.map((row) => ({ ...row, Team_Lead: "" }));

          if (
            !availableColumns.includes("Agent_email") &&
            availableColumns.includes("Agent_Email")
          )
            parsedRows = parsedRows.map((row) => ({
              ...row,
              Agent_email: row.Agent_Email,
            }));

          if (
            !availableColumns.includes("Date") &&
            availableColumns.includes("Last_Updated")
          )
            parsedRows = parsedRows.map((row) => ({
              ...row,
              Date: row.Last_Updated,
            }));

          // ── Validate required columns exist
          const requiredColumns = [
            "Date",
            "Team_Lead",
            "Client_name",
            "Agent_email",
            "Disposition_category",
          ];
          const missingColumns = requiredColumns.filter(
            (requiredCol) =>
              !Object.keys(parsedRows[0] || {}).includes(requiredCol),
          );
          if (missingColumns.length) {
            alert("Missing required columns: " + missingColumns.join(", "));
            return;
          }

          // ── Store and notify
          this.rawData = parsedRows;
          this.fileUploaded = true;
          this.showInfoBanner(
            "File uploaded! Found " + parsedRows.length + " records.",
          );
        } catch (parseError) {
          alert("Error reading file.");
          console.error(parseError);
        }
      };

      fileReader.readAsArrayBuffer(uploadedFile);
    },

    getSafeBarChart(name = "No Data") {
      return {
        series: [{ name, data: [0] }],
        options: {
          chart: { type: "bar" },
          xaxis: { categories: ["No Data"] },
        },
      };
    },

    getSafeDonutChart() {
      return {
        series: [1],
        options: {
          chart: { type: "donut" },
          labels: ["No Data"],
        },
      };
    },

    // Build / Filter / Reset
    async initializeDashboard() {
      if (!this.rawData.length) {
        alert("Please upload a data file first.");
        return;
      }
      this.isLoading = true;
      this.loadingMessage = "Building Dashboard...";
      await this.$nextTick(); // let Vue render the loading spinner before heavy work
      setTimeout(() => {
        this.parseAndEnrichData();
        this.showFilterCard = true;
        this.populateFilterDropdowns();
        this.rebuildAllTables();
        this.generateAllCharts();
        this.isLoading = false;
        this.showInfoBanner("Dashboard built successfully!");
      }, 50);
    },

    parseAndEnrichData() {
      this.filteredData = this.rawData.map((r) => ({
        ...r,
        Date: new Date(r.Date),
        Month: new Date(r.Date).toLocaleString("default", {
          month: "long",
          year: "numeric",
        }),
      }));
    },
    rebuildAllTables() {
      this.buildSummary();
      this.buildMonthly();
      this.buildAttempts();
      this.buildDisposition();
    },
    populateFilterDropdowns() {
      this.teamLeadOptions = [...new Set(this.rawData.map((r) => r.Team_Lead))]
        .sort()
        .filter(Boolean);
      this.clientOptions = [...new Set(this.rawData.map((r) => r.Client_name))]
        .sort()
        .filter(Boolean);
      this.agentOptions = [...new Set(this.rawData.map((r) => r.Agent_email))]
        .sort()
        .filter(Boolean);
    },
    onTeamLeadChange() {
      const sel = this.currentFilters.teamLeads;
      this.clientOptions = sel.length
        ? [
            ...new Set(
              this.rawData
                .filter((r) => sel.includes(r.Team_Lead))
                .map((r) => r.Client_name),
            ),
          ]
            .sort()
            .filter(Boolean)
        : [...new Set(this.rawData.map((r) => r.Client_name))]
            .sort()
            .filter(Boolean);
      this.currentFilters.clients = [];
      this.currentFilters.agents = [];
      this.updateAgentOptions();
    },
    onClientChange() {
      this.currentFilters.agents = [];
      this.updateAgentOptions();
    },
    updateAgentOptions() {
      let rows = this.rawData;
      if (this.currentFilters.teamLeads.length)
        rows = rows.filter((r) =>
          this.currentFilters.teamLeads.includes(r.Team_Lead),
        );
      if (this.currentFilters.clients.length)
        rows = rows.filter((r) =>
          this.currentFilters.clients.includes(r.Client_name),
        );
      this.agentOptions = [...new Set(rows.map((r) => r.Agent_email))]
        .sort()
        .filter(Boolean);
    },
    async applyAllFilters() {
      this.isLoading = true;
      this.loadingMessage = "Applying Filters...";
      await this.$nextTick();

      this.filteredData = this.rawData
        .filter((rawRecord) => {
          // ── Date range filter
          if (this.currentFilters.startDate || this.currentFilters.endDate) {
            const recordDate = rawRecord.Date ? new Date(rawRecord.Date) : null;
            if (!recordDate || isNaN(recordDate.getTime())) return false;

            if (this.currentFilters.startDate) {
              const startDate = new Date(this.currentFilters.startDate);
              startDate.setHours(0, 0, 0, 0);
              const recordDateNormalized = new Date(recordDate);
              recordDateNormalized.setHours(0, 0, 0, 0);
              if (recordDateNormalized < startDate) return false;
            }

            if (this.currentFilters.endDate) {
              const endDate = new Date(this.currentFilters.endDate);
              endDate.setHours(23, 59, 59, 999);
              if (recordDate > endDate) return false;
            }
          }

          // Team Lead filter
          if (
            this.currentFilters.teamLeads.length &&
            !this.currentFilters.teamLeads.includes(rawRecord.Team_Lead)
          )
            return false;

          // Client filter
          if (
            this.currentFilters.clients.length &&
            !this.currentFilters.clients.includes(rawRecord.Client_name)
          )
            return false;

          // Agent filter
          if (this.currentFilters.agents.length) {
            const agentIdentifier =
              rawRecord.Agent_email || rawRecord.Called_By;
            if (!this.currentFilters.agents.includes(agentIdentifier))
              return false;
          }

          return true;
        })
        .map((rawRecord) => ({
          ...rawRecord,
          Date: new Date(rawRecord.Date),
          Month: new Date(rawRecord.Date).toLocaleString("default", {
            month: "long",
            year: "numeric",
          }),
        }));

      this.rebuildAllTables();
      this.generateAllCharts();
      this.isLoading = false;
      this.showInfoBanner(
        "Filters applied! Showing " + this.filteredData.length + " records.",
      );
    },

    clearAllFilters() {
      this.currentFilters = {
        startDate: null,
        endDate: null,
        teamLeads: [],
        clients: [],
        agents: [],
      };
      this.averageDays = null;
      this.parseAndEnrichData();
      this.populateFilterDropdowns();
      this.rebuildAllTables();
      this.generateAllCharts();
      this.showInfoBanner("All filters have been reset!");
    },

    // Build Summary
    buildSummary() {
      const callRecords = this.filteredData;
      const isSingleDayView =
        [...new Set(callRecords.map((r) => new Date(r.Date).toDateString()))]
          .length === 1;
      const workingDaysCount = this.parsedAvgDays;
      const selectedTeamLeads = this.currentFilters.teamLeads;
      const selectedClients = this.currentFilters.clients;
      const shouldShowTLRow = selectedTeamLeads.length !== 1;
      const shouldShowClientRow =
        selectedTeamLeads.length !== 1 || selectedClients.length !== 1;

      const activeHoursInDay = isSingleDayView
        ? [
            ...new Set(callRecords.map((r) => new Date(r.Date).getHours())),
          ].sort((a, b) => a - b)
        : [];
      this.summaryHours = activeHoursInDay;

      // Headers
      const tableColumnHeaders = [
        {
          title: "Team Lead / Client / Agent",
          key: "name",
          sortable: false,
          minWidth: "220px",
        },
        { title: "Total Calls", key: "total", sortable: false, align: "end" },
        { title: "Unique Calls", key: "unique", sortable: false, align: "end" },
      ];
      if (workingDaysCount) {
        tableColumnHeaders.push({
          title: "Avg/Day Total",
          key: "avgTotal",
          sortable: false,
          align: "end",
        });
        tableColumnHeaders.push({
          title: "Avg/Day Unique",
          key: "avgUnique",
          sortable: false,
          align: "end",
        });
      }
      activeHoursInDay.forEach((hour) =>
        tableColumnHeaders.push({
          title: hour + ":00",
          key: "h_" + hour,
          sortable: false,
          align: "end",
        }),
      );
      this.summaryHeaders = tableColumnHeaders;

      // Group records
      const hierarchyByTeamLead = {};
      callRecords.forEach((callRecord) => {
        const teamLeadName = callRecord.Team_Lead || "";
        const clientName = callRecord.Client_name || "";
        const agentName = callRecord.Agent_email || callRecord.Called_By || "";
        const callHour = isSingleDayView
          ? new Date(callRecord.Date).getHours()
          : null;

        if (!hierarchyByTeamLead[teamLeadName])
          hierarchyByTeamLead[teamLeadName] = {
            clientsMap: {},
            totalCalls: 0,
            uniqueCustomers: 0,
            callsByHour: {},
          };

        if (!hierarchyByTeamLead[teamLeadName].clientsMap[clientName])
          hierarchyByTeamLead[teamLeadName].clientsMap[clientName] = {
            agentsMap: {},
            totalCalls: 0,
            uniqueCustomers: 0,
            callsByHour: {},
          };

        if (
          !hierarchyByTeamLead[teamLeadName].clientsMap[clientName].agentsMap[
            agentName
          ]
        )
          hierarchyByTeamLead[teamLeadName].clientsMap[clientName].agentsMap[
            agentName
          ] = {
            totalCalls: 0,
            uniqueCustomers: 0,
            uniqueCustomerIds: new Set(),
            callsByHour: {},
          };

        const agentData =
          hierarchyByTeamLead[teamLeadName].clientsMap[clientName].agentsMap[
            agentName
          ];
        agentData.totalCalls++;
        hierarchyByTeamLead[teamLeadName].clientsMap[clientName].totalCalls++;
        hierarchyByTeamLead[teamLeadName].totalCalls++;

        if (isSingleDayView && callHour != null) {
          hierarchyByTeamLead[teamLeadName].callsByHour[callHour] =
            (hierarchyByTeamLead[teamLeadName].callsByHour[callHour] || 0) + 1;
          hierarchyByTeamLead[teamLeadName].clientsMap[clientName].callsByHour[
            callHour
          ] =
            (hierarchyByTeamLead[teamLeadName].clientsMap[clientName]
              .callsByHour[callHour] || 0) + 1;
          agentData.callsByHour[callHour] =
            (agentData.callsByHour[callHour] || 0) + 1;
        }

        const uniqueCustomerId =
          this.extractUniqueCustomerIdentifier(callRecord);
        if (uniqueCustomerId) agentData.uniqueCustomerIds.add(uniqueCustomerId);
      });

      // Rollup unique counts bottom-up
      Object.keys(hierarchyByTeamLead).forEach((teamLeadName) => {
        const teamLeadData = hierarchyByTeamLead[teamLeadName];
        Object.keys(teamLeadData.clientsMap).forEach((clientName) => {
          const clientData = teamLeadData.clientsMap[clientName];
          Object.keys(clientData.agentsMap).forEach((agentName) => {
            clientData.agentsMap[agentName].uniqueCustomers =
              clientData.agentsMap[agentName].uniqueCustomerIds.size;
          });
          clientData.uniqueCustomers = Object.values(
            clientData.agentsMap,
          ).reduce((sum, agent) => sum + agent.uniqueCustomers, 0);
        });
        teamLeadData.uniqueCustomers = Object.values(
          teamLeadData.clientsMap,
        ).reduce((sum, client) => sum + client.uniqueCustomers, 0);
      });

      // Build flat rows
      const flatTableRows = [];
      let grandTotalCalls = 0;
      let grandUniqueCustomers = 0;

      Object.keys(hierarchyByTeamLead)
        .sort()
        .forEach((teamLeadName) => {
          const teamLeadData = hierarchyByTeamLead[teamLeadName];
          grandTotalCalls += teamLeadData.totalCalls;
          grandUniqueCustomers += teamLeadData.uniqueCustomers;

          if (shouldShowTLRow) {
            const teamLeadRow = {
              _id: "tl_" + teamLeadName,
              _type: "tl",
              _val: teamLeadName,
              name: teamLeadName,
              total: teamLeadData.totalCalls,
              unique: teamLeadData.uniqueCustomers,
              _showTL: true,
              _showCL: shouldShowClientRow,
            };
            if (workingDaysCount) {
              teamLeadRow.avgTotal = (
                teamLeadData.totalCalls / workingDaysCount
              ).toFixed(1);
              teamLeadRow.avgUnique = (
                teamLeadData.uniqueCustomers / workingDaysCount
              ).toFixed(1);
            }
            activeHoursInDay.forEach((hour) => {
              teamLeadRow["h_" + hour] = teamLeadData.callsByHour[hour] || 0;
            });
            flatTableRows.push(teamLeadRow);
          }

          Object.keys(teamLeadData.clientsMap).forEach((clientName) => {
            const clientData = teamLeadData.clientsMap[clientName];
            if (shouldShowClientRow) {
              const clientRow = {
                _id: "cl_" + teamLeadName + clientName,
                _type: "cl",
                _val: clientName,
                name: clientName,
                total: clientData.totalCalls,
                unique: clientData.uniqueCustomers,
                _showTL: shouldShowTLRow,
                _showCL: true,
              };
              if (workingDaysCount) {
                clientRow.avgTotal = (
                  clientData.totalCalls / workingDaysCount
                ).toFixed(1);
                clientRow.avgUnique = (
                  clientData.uniqueCustomers / workingDaysCount
                ).toFixed(1);
              }
              activeHoursInDay.forEach((hour) => {
                clientRow["h_" + hour] = clientData.callsByHour[hour] || 0;
              });
              flatTableRows.push(clientRow);
            }

            Object.keys(clientData.agentsMap).forEach(
              (agentName, agentIndex) => {
                const agentData = clientData.agentsMap[agentName];
                const agentRow = {
                  _id: "ag_" + teamLeadName + clientName + agentName,
                  _type: "ag",
                  _val: agentName,
                  name: agentName,
                  total: agentData.totalCalls,
                  unique: agentData.uniqueCustomers,
                  _showTL: shouldShowTLRow,
                  _showCL: shouldShowClientRow,
                  _even: agentIndex % 2 === 0,
                };
                if (workingDaysCount) {
                  agentRow.avgTotal = (
                    agentData.totalCalls / workingDaysCount
                  ).toFixed(1);
                  agentRow.avgUnique = (
                    agentData.uniqueCustomers / workingDaysCount
                  ).toFixed(1);
                }
                activeHoursInDay.forEach((hour) => {
                  agentRow["h_" + hour] = agentData.callsByHour[hour] || 0;
                });
                flatTableRows.push(agentRow);
              },
            );
          });
        });
      this.summaryRows = flatTableRows;

      // Grand total row
      const grandTotalRow = {
        total: grandTotalCalls,
        unique: grandUniqueCustomers,
      };
      if (workingDaysCount) {
        grandTotalRow.avgTotal = (grandTotalCalls / workingDaysCount).toFixed(
          1,
        );
        grandTotalRow.avgUnique = (
          grandUniqueCustomers / workingDaysCount
        ).toFixed(1);
      }
      activeHoursInDay.forEach((hour) => {
        grandTotalRow["h_" + hour] = callRecords.filter(
          (r) => new Date(r.Date).getHours() === hour,
        ).length;
      });
      this.summaryGrand = grandTotalRow;
    },

    // Build Monthly
    buildMonthly() {
      const callRecords = this.filteredData;

      // ── Group records: Month → Day → Disposition
      const monthlyHierarchy = {};
      callRecords.forEach((callRecord) => {
        const callDate = new Date(callRecord.Date);
        const monthLabel = callRecord.Month;
        const dayLabel =
          callDate.getDate() +
          " " +
          callDate.toLocaleString("default", { month: "short" });
        const dispositionCategory =
          callRecord.Disposition_category || "Unknown";

        if (!monthlyHierarchy[monthLabel])
          monthlyHierarchy[monthLabel] = { days: {}, totals: {} };

        if (!monthlyHierarchy[monthLabel].days[dayLabel])
          monthlyHierarchy[monthLabel].days[dayLabel] = {};

        monthlyHierarchy[monthLabel].days[dayLabel][dispositionCategory] =
          (monthlyHierarchy[monthLabel].days[dayLabel][dispositionCategory] ||
            0) + 1;

        monthlyHierarchy[monthLabel].totals[dispositionCategory] =
          (monthlyHierarchy[monthLabel].totals[dispositionCategory] || 0) + 1;
      });

      // ── Collect all unique disposition categories (sorted)
      const allDispositionCategories = [
        ...new Set(callRecords.map((r) => r.Disposition_category || "Unknown")),
      ].sort();
      this.monthlyDisps = allDispositionCategories;

      // ── Build column headers: Name | Disp1 | Disp2 | ... | Total
      const tableColumnHeaders = [
        {
          title: "Month / Date",
          key: "name",
          sortable: false,
          minWidth: "200px",
        },
      ];
      allDispositionCategories.forEach((dispositionCategory) =>
        tableColumnHeaders.push({
          title: dispositionCategory,
          key: this.generateSafeKey(dispositionCategory),
          sortable: false,
          align: "end",
        }),
      );
      tableColumnHeaders.push({
        title: "Total",
        key: "_tot",
        sortable: false,
        align: "end",
      });
      this.monthlyHeaders = tableColumnHeaders;

      // ── Build flat rows: Month header row, then one row per day underneath
      const flatTableRows = [];
      Object.keys(monthlyHierarchy)
        .sort((monthA, monthB) => new Date(monthA) - new Date(monthB))
        .forEach((monthLabel) => {
          const monthData = monthlyHierarchy[monthLabel];

          // Month summary row
          const monthRow = {
            _id: "m_" + monthLabel,
            _type: "month",
            _month: monthLabel,
            name: monthLabel,
            _tot: 0,
          };
          allDispositionCategories.forEach((dispositionCategory) => {
            monthRow[this.generateSafeKey(dispositionCategory)] =
              monthData.totals[dispositionCategory] || 0;
            monthRow._tot += monthData.totals[dispositionCategory] || 0;
          });
          flatTableRows.push(monthRow);

          // Day detail rows (sorted by day number)
          Object.keys(monthData.days)
            .sort((dayA, dayB) => parseInt(dayA) - parseInt(dayB))
            .forEach((dayLabel) => {
              const dayRow = {
                _id: "d_" + monthLabel + dayLabel,
                _type: "day",
                _month: monthLabel,
                _dk: dayLabel,
                name: dayLabel,
                _tot: 0,
              };
              allDispositionCategories.forEach((dispositionCategory) => {
                dayRow[this.generateSafeKey(dispositionCategory)] =
                  monthData.days[dayLabel][dispositionCategory] || 0;
                dayRow._tot +=
                  monthData.days[dayLabel][dispositionCategory] || 0;
              });
              flatTableRows.push(dayRow);
            });
        });
      this.monthlyRows = flatTableRows;

      // ── Build grand total row
      const grandTotalRow = { _tot: 0 };
      allDispositionCategories.forEach((dispositionCategory) => {
        const categoryTotal = Object.values(monthlyHierarchy).reduce(
          (runningTotal, monthData) =>
            runningTotal + (monthData.totals[dispositionCategory] || 0),
          0,
        );
        grandTotalRow[this.generateSafeKey(dispositionCategory)] =
          categoryTotal;
        grandTotalRow._tot += categoryTotal;
      });
      this.monthlyGrand = grandTotalRow;
    },

    // Build Attempts
    buildAttempts() {
      const callRecords = this.filteredData;

      // Check if the file contains an attempts column at all
      const hasAttemptsColumn =
        callRecords.length &&
        (callRecords[0].hasOwnProperty("No of attempts") ||
          callRecords[0].hasOwnProperty("No Of Attempts"));

      this.attemptsHasData = hasAttemptsColumn;

      if (!hasAttemptsColumn) {
        this.attemptsRows = [];
        this.attemptsKeys = [];
        this.attemptsGrand = {};
        this.attemptsHeaders = [];
        return;
      }

      // ── Group records: Client → Agent → Disposition → Attempt count
      const hierarchyByClient = {};
      callRecords.forEach((callRecord) => {
        const clientName = callRecord.Client_name || "Unknown";
        const agentName =
          callRecord.Agent_email || callRecord.Called_By || "Unknown";
        const dispositionCategory =
          callRecord.Disposition_category || "Yet to work";
        const attemptCount = parseInt(
          callRecord["No of attempts"] || callRecord["No Of Attempts"] || 0,
        );

        if (!hierarchyByClient[clientName])
          hierarchyByClient[clientName] = {
            agents: {},
            totalCalls: 0,
            callsByAttemptCount: {},
          };

        if (!hierarchyByClient[clientName].agents[agentName])
          hierarchyByClient[clientName].agents[agentName] = {
            disps: {},
            totalCalls: 0,
            callsByAttemptCount: {},
          };

        if (
          !hierarchyByClient[clientName].agents[agentName].disps[
            dispositionCategory
          ]
        )
          hierarchyByClient[clientName].agents[agentName].disps[
            dispositionCategory
          ] = { totalCalls: 0, callsByAttemptCount: {} };

        const dispositionData =
          hierarchyByClient[clientName].agents[agentName].disps[
            dispositionCategory
          ];

        // Increment at all 3 levels
        dispositionData.totalCalls++;
        dispositionData.callsByAttemptCount[attemptCount] =
          (dispositionData.callsByAttemptCount[attemptCount] || 0) + 1;

        hierarchyByClient[clientName].agents[agentName].totalCalls++;
        hierarchyByClient[clientName].agents[agentName].callsByAttemptCount[
          attemptCount
        ] =
          (hierarchyByClient[clientName].agents[agentName].callsByAttemptCount[
            attemptCount
          ] || 0) + 1;

        hierarchyByClient[clientName].totalCalls++;
        hierarchyByClient[clientName].callsByAttemptCount[attemptCount] =
          (hierarchyByClient[clientName].callsByAttemptCount[attemptCount] ||
            0) + 1;
      });

      // ── Collect all unique attempt numbers and sort ascending (1, 2, 3 ...)
      const uniqueAttemptNumbers = new Set();
      Object.values(hierarchyByClient).forEach((clientData) =>
        Object.keys(clientData.callsByAttemptCount).forEach((attemptNum) =>
          uniqueAttemptNumbers.add(parseInt(attemptNum)),
        ),
      );
      const sortedAttemptNumbers = Array.from(uniqueAttemptNumbers).sort(
        (a, b) => a - b,
      );
      this.attemptsKeys = sortedAttemptNumbers;

      // ── Build column headers: Name | 1 | 2 | 3 | ... | Grand Total
      const tableColumnHeaders = [
        {
          title: "CLIENT / AGENT / DISPO",
          key: "name",
          sortable: false,
          minWidth: "220px",
        },
      ];
      sortedAttemptNumbers.forEach((attemptNum) =>
        tableColumnHeaders.push({
          title: String(attemptNum),
          key: "a_" + attemptNum,
          sortable: false,
          align: "end",
        }),
      );
      tableColumnHeaders.push({
        title: "Grand Total",
        key: "_tot",
        sortable: false,
        align: "end",
      });
      this.attemptsHeaders = tableColumnHeaders;

      // ── Build flat rows: Client → Agent → Disposition
      const flatTableRows = [];
      Object.keys(hierarchyByClient)
        .sort()
        .forEach((clientName) => {
          const clientData = hierarchyByClient[clientName];

          const clientRow = {
            _id: "ac_" + clientName,
            _type: "cl",
            _val: clientName,
            name: clientName,
            _tot: clientData.totalCalls,
          };
          sortedAttemptNumbers.forEach((attemptNum) => {
            clientRow["a_" + attemptNum] =
              clientData.callsByAttemptCount[attemptNum] || 0;
          });
          flatTableRows.push(clientRow);

          Object.keys(clientData.agents)
            .sort()
            .forEach((agentName) => {
              const agentData = clientData.agents[agentName];

              const agentRow = {
                _id: "aa_" + clientName + agentName,
                _type: "ag_att",
                _val: agentName,
                _clVal: clientName,
                name: agentName,
                _tot: agentData.totalCalls,
              };
              sortedAttemptNumbers.forEach((attemptNum) => {
                agentRow["a_" + attemptNum] =
                  agentData.callsByAttemptCount[attemptNum] || 0;
              });
              flatTableRows.push(agentRow);

              Object.keys(agentData.disps)
                .sort()
                .forEach((dispositionCategory) => {
                  const dispositionData = agentData.disps[dispositionCategory];

                  const dispositionRow = {
                    _id: "ad_" + clientName + agentName + dispositionCategory,
                    _type: "disp",
                    _val: dispositionCategory,
                    _agVal: agentName,
                    name: dispositionCategory,
                    _tot: dispositionData.totalCalls,
                  };
                  sortedAttemptNumbers.forEach((attemptNum) => {
                    dispositionRow["a_" + attemptNum] =
                      dispositionData.callsByAttemptCount[attemptNum] || 0;
                  });
                  flatTableRows.push(dispositionRow);
                });
            });
        });
      this.attemptsRows = flatTableRows;

      // ── Grand total row
      const grandTotalRow = {
        _tot: Object.values(hierarchyByClient).reduce(
          (sum, clientData) => sum + clientData.totalCalls,
          0,
        ),
      };
      sortedAttemptNumbers.forEach((attemptNum) => {
        grandTotalRow["a_" + attemptNum] = Object.values(
          hierarchyByClient,
        ).reduce(
          (sum, clientData) =>
            sum + (clientData.callsByAttemptCount[attemptNum] || 0),
          0,
        );
      });
      this.attemptsGrand = grandTotalRow;
    },

    // Build Disposition
    buildDisposition() {
      const callRecords = this.filteredData;

      const uniqueClients = [
        ...new Set(callRecords.map((r) => r.Client_name || "Unknown")),
      ].sort();
      const uniqueDispositions = [
        ...new Set(callRecords.map((r) => r.Disposition_category || "Unknown")),
      ].sort();
      this.dispClients = uniqueClients;

      // ── Build column headers: Disposition | Client1 | Client2 | ... | Total
      const tableColumnHeaders = [
        {
          title: "Disposition / Client",
          key: "name",
          sortable: false,
          minWidth: "200px",
        },
      ];
      uniqueClients.forEach((clientName) =>
        tableColumnHeaders.push({
          title: clientName,
          key: this.generateSafeKey(clientName),
          sortable: false,
          align: "end",
        }),
      );
      tableColumnHeaders.push({
        title: "Total",
        key: "_tot",
        sortable: false,
        align: "end",
      });
      this.dispHeaders = tableColumnHeaders;

      if (!uniqueDispositions.length) {
        this.dispRows = [];
        this.dispGrand = {};
        return;
      }

      // ── Count calls per Disposition + Client combination
      const callCountByDispositionAndClient = {};
      callRecords.forEach((callRecord) => {
        const dispositionCategory =
          callRecord.Disposition_category || "Unknown";
        const clientName = callRecord.Client_name || "Unknown";

        if (!callCountByDispositionAndClient[dispositionCategory])
          callCountByDispositionAndClient[dispositionCategory] = {};

        callCountByDispositionAndClient[dispositionCategory][clientName] =
          (callCountByDispositionAndClient[dispositionCategory][clientName] ||
            0) + 1;
      });

      // ── Build one row per disposition category
      const flatTableRows = uniqueDispositions.map((dispositionCategory) => {
        const dispositionRow = {
          _id: "dc_" + dispositionCategory,
          _disp: dispositionCategory,
          name: dispositionCategory,
          _tot: 0,
        };

        uniqueClients.forEach((clientName) => {
          const cellValue =
            (callCountByDispositionAndClient[dispositionCategory] &&
              callCountByDispositionAndClient[dispositionCategory][
                clientName
              ]) ||
            0;
          dispositionRow[this.generateSafeKey(clientName)] = cellValue;
          dispositionRow._tot += cellValue;
        });

        return dispositionRow;
      });
      this.dispRows = flatTableRows;

      // ── Grand total row: sum of each client column across all dispositions
      const grandTotalRow = { _tot: 0 };
      uniqueClients.forEach((clientName) => {
        const clientColumnTotal = uniqueDispositions.reduce(
          (runningTotal, dispositionCategory) =>
            runningTotal +
            ((callCountByDispositionAndClient[dispositionCategory] &&
              callCountByDispositionAndClient[dispositionCategory][
                clientName
              ]) ||
              0),
          0,
        );
        grandTotalRow[this.generateSafeKey(clientName)] = clientColumnTotal;
        grandTotalRow._tot += clientColumnTotal;
      });
      this.dispGrand = grandTotalRow;
    },

    // Charts
    generateAllCharts() {
      this.chartRerenderTriggerKey++;

      // Guard: if no data, load safe placeholder charts and stop
      if (!this.filteredData || this.filteredData.length === 0) {
        this.dispositionChart = this.getSafeDonutChart();
        this.teamPerformanceChart = this.getSafeBarChart();
        this.dailyTrendChart = this.getSafeBarChart();
        this.callVolumeChart = this.getSafeBarChart();
        this.dispositionSnapshotChart = this.getSafeBarChart();
        this.balanceSnapshotChart = this.getSafeBarChart();
        return;
      }

      const callRecords = this.filteredData;
      const isDark = this.isDarkTheme;
      const textColor = isDark ? "#ecf0f1" : "#2c3e50";
      const gridLineColor = isDark
        ? "rgba(255,255,255,0.1)"
        : "rgba(0,0,0,0.08)";

      const sharedChartConfig = {
        theme: { mode: isDark ? "dark" : "light" },
        chart: {
          background: "transparent",
          fontFamily: "inherit",
          toolbar: { show: true },
        },
        tooltip: { theme: isDark ? "dark" : "light" },
      };

      const chartColorPalette = [
        "#4361ee",
        "#4895ef",
        "#4cc9f0",
        "#f77f00",
        "#e63946",
        "#52b788",
        "#8b5cf6",
        "#ef4444",
        "#f59e0b",
        "#10b981",
      ];
      const chartTitleStyle = {
        fontSize: "15px",
        fontWeight: 700,
        color: textColor,
      };

      // Always build ALL charts — v-if in template handles visibility.
      // Skipping stale charts causes ApexCharts watcher crashes when re-shown.

      // ── Chart 1: Disposition Donut
      const dispositionCountMap = {};
      callRecords.forEach((record) => {
        const category = record.Disposition_category || "Unknown";
        dispositionCountMap[category] =
          (dispositionCountMap[category] || 0) + 1;
      });
      this.dispositionChart = {
        series: Object.values(dispositionCountMap).length
          ? Object.values(dispositionCountMap)
          : [0],
        options: {
          ...sharedChartConfig,
          chart: { ...sharedChartConfig.chart, type: "donut" },
          labels: Object.keys(dispositionCountMap).length
            ? Object.keys(dispositionCountMap)
            : ["No data"],
          colors: chartColorPalette,
          title: {
            text: "Call Disposition Distribution",
            align: "center",
            style: chartTitleStyle,
          },
          legend: { position: "bottom", labels: { colors: textColor } },
          dataLabels: { enabled: true },
          plotOptions: { pie: { donut: { size: "60%" } } },
        },
      };

      // ── Chart 2: Team Performance Bar
      const callsPerTeamLead = {};
      callRecords.forEach((record) => {
        callsPerTeamLead[record.Team_Lead] =
          (callsPerTeamLead[record.Team_Lead] || 0) + 1;
      });
      const teamLeadsSortedByVolume = Object.entries(callsPerTeamLead).sort(
        ([, a], [, b]) => b - a,
      );
      this.teamPerformanceChart = {
        series: [
          {
            name: "Total Calls",
            data: teamLeadsSortedByVolume.length
              ? teamLeadsSortedByVolume.map(([, count]) => count)
              : [0],
          },
        ],
        options: {
          ...sharedChartConfig,
          chart: { ...sharedChartConfig.chart, type: "bar" },
          xaxis: {
            categories: teamLeadsSortedByVolume.length
              ? teamLeadsSortedByVolume.map(([name]) => name)
              : ["No data"],
            labels: { style: { colors: textColor }, rotate: -30 },
          },
          yaxis: { labels: { style: { colors: textColor } } },
          colors: ["#4361ee"],
          title: {
            text: "Team Performance",
            align: "center",
            style: chartTitleStyle,
          },
          dataLabels: {
            enabled: true,
            style: { fontSize: "11px", colors: [isDark ? "#fff" : "#333"] },
          },
          plotOptions: { bar: { borderRadius: 6 } },
          grid: { borderColor: gridLineColor },
        },
      };

      // ── Chart 3: Daily Trend Line
      const callsPerDayMap = {};
      callRecords.forEach((record) => {
        const dateObj = new Date(record.Date);
        const dayLabel =
          dateObj.getDate() +
          "-" +
          dateObj.toLocaleString("default", { month: "short" }) +
          "-" +
          dateObj.getFullYear();
        callsPerDayMap[dayLabel] = (callsPerDayMap[dayLabel] || 0) + 1;
      });
      const dayLabelsSortedChronologically = Object.keys(callsPerDayMap).sort(
        (labelA, labelB) => {
          const [dayA, monthA, yearA] = labelA.split("-");
          const [dayB, monthB, yearB] = labelB.split("-");
          return (
            new Date(monthA + " " + dayA + " " + yearA) -
            new Date(monthB + " " + dayB + " " + yearB)
          );
        },
      );
      const lineStyleToCurveType = {
        wave: "smooth",
        trend: "monotoneCubic",
        smooth: "smooth",
        stepped: "stepline",
      };
      this.dailyTrendChart = {
        series: [
          {
            name: "Calls per Day",
            data: dayLabelsSortedChronologically.length
              ? dayLabelsSortedChronologically.map(
                  (label) => callsPerDayMap[label],
                )
              : [0],
          },
        ],
        options: {
          ...sharedChartConfig,
          chart: { ...sharedChartConfig.chart, type: "line" },
          xaxis: {
            categories: dayLabelsSortedChronologically.length
              ? dayLabelsSortedChronologically
              : ["No data"],
            labels: { style: { colors: textColor }, rotate: -30 },
          },
          yaxis: { labels: { style: { colors: textColor } } },
          colors: ["#4cc9f0"],
          title: {
            text: "Daily Call Trends",
            align: "center",
            style: chartTitleStyle,
          },
          stroke: {
            curve: lineStyleToCurveType[this.chartStyle] || "smooth",
            width: 3,
          },
          fill: {
            type: "gradient",
            gradient: { shade: "light", opacityFrom: 0.7, opacityTo: 0.5 },
          },
          markers: { size: 4 },
          grid: { borderColor: gridLineColor },
        },
      };

      // ── Chart 4: Top 10 Agents by Call Volume
      const callsPerAgentMap = {};
      callRecords.forEach((record) => {
        const agentIdentifier = record.Agent_email || record.Called_By;
        if (agentIdentifier)
          callsPerAgentMap[agentIdentifier] =
            (callsPerAgentMap[agentIdentifier] || 0) + 1;
      });
      const top10AgentsByCallVolume = Object.entries(callsPerAgentMap)
        .sort(([, a], [, b]) => b - a)
        .slice(0, 10);
      this.callVolumeChart = {
        series: [
          {
            name: "Total Calls",
            data: top10AgentsByCallVolume.length
              ? top10AgentsByCallVolume.map(([, count]) => count)
              : [0],
          },
        ],
        options: {
          ...sharedChartConfig,
          chart: { ...sharedChartConfig.chart, type: "bar" },
          xaxis: {
            categories: top10AgentsByCallVolume.length
              ? top10AgentsByCallVolume.map(([name]) => name)
              : ["No data"],
            labels: { style: { colors: textColor }, rotate: -30 },
          },
          yaxis: { labels: { style: { colors: textColor } } },
          colors: ["#52b788"],
          title: {
            text: "Top 10 Agents by Call Volume",
            align: "center",
            style: chartTitleStyle,
          },
          dataLabels: {
            enabled: true,
            style: { fontSize: "11px", colors: [isDark ? "#fff" : "#333"] },
          },
          plotOptions: { bar: { borderRadius: 6 } },
          grid: { borderColor: gridLineColor },
        },
      };

      // ── Chart 5: Disposition Snapshot Bar
      const dispositionCountsForBar = {};
      callRecords.forEach((record) => {
        const category = record.Disposition_category || "Unknown";
        dispositionCountsForBar[category] =
          (dispositionCountsForBar[category] || 0) + 1;
      });
      const dispositionsSortedByCount = Object.entries(
        dispositionCountsForBar,
      ).sort(([, a], [, b]) => b - a);
      this.dispositionSnapshotChart = {
        series: [
          {
            name: "Call Count",
            data: dispositionsSortedByCount.length
              ? dispositionsSortedByCount.map(([, count]) => count)
              : [0],
          },
        ],
        options: {
          ...sharedChartConfig,
          chart: { ...sharedChartConfig.chart, type: "bar" },
          xaxis: {
            categories: dispositionsSortedByCount.length
              ? dispositionsSortedByCount.map(([name]) => name)
              : ["No data"],
            labels: { style: { colors: textColor }, rotate: -30 },
          },
          yaxis: { labels: { style: { colors: textColor } } },
          colors: ["#f77f00"],
          title: {
            text: "Disposition Category Snapshot",
            align: "center",
            style: chartTitleStyle,
          },
          dataLabels: {
            enabled: true,
            style: { fontSize: "11px", colors: [isDark ? "#fff" : "#333"] },
          },
          plotOptions: { bar: { borderRadius: 6 } },
          grid: { borderColor: gridLineColor },
        },
      };

      // ── Chart 6: Balance Distribution (conditional — only if column exists)
      this.dataFileHasBalanceColumn =
        callRecords.length > 0 &&
        callRecords[0].hasOwnProperty("Current_Balance");
      if (this.dataFileHasBalanceColumn) {
        const balanceTierCounts = {
          "0-1000": 0,
          "1000-5000": 0,
          "5000-10000": 0,
          "10000-50000": 0,
          "50000+": 0,
        };
        callRecords.forEach((record) => {
          const balanceAmount = parseFloat(record.Current_Balance) || 0;
          if (balanceAmount <= 1000) balanceTierCounts["0-1000"]++;
          else if (balanceAmount <= 5000) balanceTierCounts["1000-5000"]++;
          else if (balanceAmount <= 10000) balanceTierCounts["5000-10000"]++;
          else if (balanceAmount <= 50000) balanceTierCounts["10000-50000"]++;
          else balanceTierCounts["50000+"]++;
        });
        this.balanceSnapshotChart = {
          series: [
            { name: "Customer Count", data: Object.values(balanceTierCounts) },
          ],
          options: {
            ...sharedChartConfig,
            chart: { ...sharedChartConfig.chart, type: "bar" },
            xaxis: {
              categories: Object.keys(balanceTierCounts),
              labels: { style: { colors: textColor } },
            },
            yaxis: { labels: { style: { colors: textColor } } },
            colors: ["#52b788"],
            title: {
              text: "Current Balance Distribution",
              align: "center",
              style: chartTitleStyle,
            },
            dataLabels: {
              enabled: true,
              style: { colors: [isDark ? "#fff" : "#333"] },
            },
            plotOptions: { bar: { borderRadius: 6 } },
            grid: { borderColor: gridLineColor },
          },
        };
      }
    },

    // Drilldown helpers
    openDetailModal(modalTitle, drilldownRecords) {
      // Internal metadata keys to hide from the modal table
      const internalKeysToSkip = new Set([
        "Month",
        "_type",
        "_val",
        "_id",
        "_even",
        "_showTL",
        "_showCL",
        "_clVal",
        "_agVal",
        "_disp",
        "_month",
        "_dk",
        "_tot",
        "_rowIdx",
      ]);

      const visibleColumns = drilldownRecords.length
        ? Object.keys(drilldownRecords[0]).filter(
            (colKey) =>
              !colKey.startsWith("_") && !internalKeysToSkip.has(colKey),
          )
        : [];

      const modalColumnHeaders = visibleColumns.map((colKey) => ({
        title: colKey.replace(/_/g, " "),
        key: colKey,
        sortable: true,
        minWidth: "110px",
      }));

      const modalDisplayItems = drilldownRecords.map((dataRow, rowIndex) => {
        const displayItem = { _rowIdx: rowIndex };
        visibleColumns.forEach((colKey) => {
          displayItem[colKey] = this.formatCellValue(dataRow, colKey);
        });
        return displayItem;
      });

      this.modal = {
        open: true,
        title: modalTitle,
        rows: drilldownRecords,
        cols: visibleColumns,
        headers: modalColumnHeaders,
        items: modalDisplayItems,
        search: "",
      };
    },

    deduplicateByCustomerId(recordsArray) {
      // Keeps only the first record per unique customer identifier
      const seenCustomerIds = new Set();
      return recordsArray.filter((record) => {
        const customerId = this.extractUniqueCustomerIdentifier(record);
        if (!customerId || seenCustomerIds.has(customerId)) return false;
        seenCustomerIds.add(customerId);
        return true;
      });
    },

    drilldownSummaryCell(rowType, entityValue, metricType) {
      const callRecords = this.filteredData;

      let drilldownRecords =
        rowType === "tl"
          ? callRecords.filter((r) => r.Team_Lead === entityValue)
          : rowType === "cl"
          ? callRecords.filter((r) => r.Client_name === entityValue)
          : callRecords.filter(
              (r) => (r.Agent_email || r.Called_By) === entityValue,
            );

      if (metricType === "unique")
        drilldownRecords = this.deduplicateByCustomerId(drilldownRecords);

      const rowTypeLabel =
        rowType === "tl" ? "Team Lead" : rowType === "cl" ? "Client" : "Agent";

      this.openDetailModal(
        rowTypeLabel +
          ": " +
          entityValue +
          " – " +
          (metricType === "total" ? "Total" : "Unique") +
          " Calls",
        drilldownRecords,
      );
    },

    drilldownHourlyCell(rowType, entityValue, selectedHour) {
      const callRecords = this.filteredData;
      const matchesHour = (record) =>
        new Date(record.Date).getHours() === selectedHour;

      const drilldownRecords =
        rowType === "tl"
          ? callRecords.filter(
              (r) => r.Team_Lead === entityValue && matchesHour(r),
            )
          : rowType === "cl"
          ? callRecords.filter(
              (r) => r.Client_name === entityValue && matchesHour(r),
            )
          : callRecords.filter(
              (r) =>
                (r.Agent_email || r.Called_By) === entityValue &&
                matchesHour(r),
            );

      this.openDetailModal(
        (entityValue || "All") + " – Hour " + selectedHour + ":00",
        drilldownRecords,
      );
    },

    drilldownMonthlyDayCell(monthLabel, dayLabel, dispositionCategory) {
      const drilldownRecords = this.filteredData.filter((record) => {
        const recordDate = new Date(record.Date);
        const recordDayKey =
          recordDate.getDate() +
          " " +
          recordDate.toLocaleString("default", { month: "short" });
        return (
          record.Month === monthLabel &&
          recordDayKey === dayLabel &&
          (record.Disposition_category || "Unknown") === dispositionCategory
        );
      });
      this.openDetailModal(
        monthLabel + " – " + dayLabel + " – " + dispositionCategory,
        drilldownRecords,
      );
    },

    drilldownDispositionClientCell(dispositionCategory, clientName) {
      const drilldownRecords = this.filteredData.filter((record) => {
        const clientMatches =
          clientName === "ALL" ||
          (record.Client_name || "Unknown") === clientName;
        const dispositionMatches =
          dispositionCategory === "ALL" ||
          (record.Disposition_category || "Unknown") === dispositionCategory;
        return clientMatches && dispositionMatches;
      });
      this.openDetailModal(
        dispositionCategory === "ALL"
          ? "Client: " + clientName + " – All Dispositions"
          : "Disposition: " + dispositionCategory + " – Client: " + clientName,
        drilldownRecords,
      );
    },

    drilldownAttemptCell(tableRow, attemptNumber) {
      const callRecords = this.filteredData;
      const getAttemptCount = (record) =>
        parseInt(record["No of attempts"] || record["No Of Attempts"] || 0);

      let drilldownRecords;
      if (tableRow._type === "cl")
        drilldownRecords = callRecords.filter(
          (r) =>
            (r.Client_name || "Unknown") === tableRow._val &&
            getAttemptCount(r) === attemptNumber,
        );
      else if (tableRow._type === "ag_att")
        drilldownRecords = callRecords.filter(
          (r) =>
            (r.Agent_email || r.Called_By || "Unknown") === tableRow._val &&
            getAttemptCount(r) === attemptNumber,
        );
      else
        drilldownRecords = callRecords.filter(
          (r) =>
            (r.Disposition_category || "Yet to work") === tableRow._val &&
            (r.Agent_email || r.Called_By || "Unknown") === tableRow._agVal &&
            getAttemptCount(r) === attemptNumber,
        );

      this.openDetailModal(
        tableRow.name + " – Attempt " + attemptNumber,
        drilldownRecords,
      );
    },

    drilldownAttemptTotalCell(tableRow) {
      const callRecords = this.filteredData;

      let drilldownRecords;
      if (tableRow._type === "cl")
        drilldownRecords = callRecords.filter(
          (r) => (r.Client_name || "Unknown") === tableRow._val,
        );
      else if (tableRow._type === "ag_att")
        drilldownRecords = callRecords.filter(
          (r) => (r.Agent_email || r.Called_By || "Unknown") === tableRow._val,
        );
      else
        drilldownRecords = callRecords.filter(
          (r) =>
            (r.Disposition_category || "Yet to work") === tableRow._val &&
            (r.Agent_email || r.Called_By || "Unknown") === tableRow._agVal,
        );

      this.openDetailModal(tableRow.name + " – All Calls", drilldownRecords);
    },

    // Export
    buildArrayOfArraysForExport(columnHeaders, dataRows, grandTotalRow) {
      // Converts table data into a 2D array that SheetJS can write to Excel/CSV
      const headerRow = columnHeaders.map((header) => header.title);

      const bodyRows = dataRows.map((dataRow) =>
        columnHeaders.map((header) => {
          const cellValue = dataRow[header.key];
          return cellValue != null ? cellValue : "";
        }),
      );

      const footerRow = columnHeaders.map((header) =>
        header.key === "name"
          ? "GRAND TOTAL"
          : grandTotalRow[header.key] != null
          ? grandTotalRow[header.key]
          : "",
      );

      return [headerRow, ...bodyRows, footerRow];
    },

    exportTabToFile(exportFormat, tabName) {
      const tabExportConfigMap = {
        summary: {
          heads: this.summaryHeaders,
          rows: this.summaryRows,
          grand: this.summaryGrand,
          fname: "Summary_Dashboard",
        },
        monthly: {
          heads: this.monthlyHeaders,
          rows: this.monthlyRows,
          grand: this.monthlyGrand,
          fname: "Monthly_Disposition",
        },
        attempts: {
          heads: this.attemptsHeaders,
          rows: this.attemptsRows,
          grand: this.attemptsGrand,
          fname: "Attempts_Analysis",
        },
        disposition: {
          heads: this.dispHeaders,
          rows: this.dispRows,
          grand: this.dispGrand,
          fname: "Disposition_Summary",
        },
      };

      const {
        heads: columnHeaders,
        rows: tableRows,
        grand: grandTotalRow,
        fname: baseFileName,
      } = tabExportConfigMap[tabName];

      if (!tableRows.length) {
        this.showInfoBanner("No data to export");
        return;
      }

      const exportData = this.buildArrayOfArraysForExport(
        columnHeaders,
        tableRows,
        grandTotalRow,
      );
      const todayString = new Date().toISOString().split("T")[0]; // "2024-01-15"

      if (exportFormat === "email") {
        // Copy as tab-separated text for pasting into emails
        navigator.clipboard
          .writeText(
            baseFileName +
              " Report – " +
              todayString +
              "\n\n" +
              exportData.map((row) => row.join("\t")).join("\n"),
          )
          .then(() => this.showInfoBanner("Copied to clipboard!"));
        return;
      }

      // Write as Excel or CSV file
      const worksheet = XLSX.utils.aoa_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      XLSX.writeFile(
        workbook,
        baseFileName +
          "_" +
          todayString +
          "." +
          (exportFormat === "csv" ? "csv" : "xlsx"),
      );
    },

    exportModalToExcel() {
      if (!this.modal.items.length) return;

      const headerRow = this.modal.cols.map((colKey) =>
        colKey.replace(/_/g, " "),
      );
      const dataRows = this.modal.items.map((modalItem) =>
        this.modal.cols.map((colKey) =>
          modalItem[colKey] != null ? modalItem[colKey] : "",
        ),
      );

      const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

      const safeFileName = (this.modal.title || "Export").replace(
        /[^\w\s]/gi,
        "_",
      );
      const todayString = new Date().toISOString().split("T")[0];
      XLSX.writeFile(workbook, safeFileName + "_" + todayString + ".xlsx");
    },
  },
};
</script>

<style scoped>
/* App & Global */
.dashboard-app-light {
  font-family: "DM Sans", system-ui, -apple-system, sans-serif;
  background-image: linear-gradient(to bottom, #eefbff, #f3eeff) !important;
  min-height: 100vh;
}
.dashboard-app-dark {
  font-family: "DM Sans", system-ui, -apple-system, sans-serif;
  background-image: linear-gradient(
    to bottom,
    #020610 0%,
    #0a213e 50%,
    #0d3d5c 100%
  ) !important;
  min-height: 100vh;
}
/* .v-application.v-theme--light {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}
.v-application.v-theme--dark {
  background: linear-gradient(135deg, #1a1a2e 0%, #2c3e50 100%) !important;
} */
.v-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.v-card:hover {
  transform: translateY(-2px);
}
.header-card {
  backdrop-filter: blur(12px);
}
/* .v-theme--dark .header-card {
  background: rgba(30, 40, 60, 0.95) !important;
} */
.header-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, #4361ee, #4cc9f0);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.build-btn-light {
  background-image: linear-gradient(to left, #4f8ef7, #00d4ff) !important;
  letter-spacing: 0.5px;
}

.build-btn-dark {
  background-image: linear-gradient(to left, #0d9488, #00f2fe) !important;
  letter-spacing: 0.5px;
}

.filter-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #666;
}
.v-theme--dark .filter-label {
  color: #aaa;
}
.tab-section-title {
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
}
.chart-card {
  position: relative;
  overflow: hidden;
}
.chart-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #4361ee, #4cc9f0, #52b788);
  border-radius: 12px 12px 0 0;
}
.loading-card {
  background: rgba(255, 255, 255, 0.97) !important;
  backdrop-filter: blur(20px);
}
.v-theme--dark .loading-card {
  background: rgba(30, 42, 60, 0.97) !important;
}

/* HIERARCHY TABLE — shared styles for ALL v-data-tables */

/* Fixed Header */
.hier-table table thead tr th {
  background: #f1f3ff !important;
  font-weight: 700 !important;
  font-size: 12.5px !important;
  white-space: nowrap;
  padding: 10px 14px !important;
  border-bottom: 2px solid rgba(102, 126, 234, 0.25) !important;
  color: #2c3e50 !important;
}
.v-theme--dark .hier-table table thead tr th {
  background: #1e2a40 !important;
  color: #e0e0e0 !important;
}

/* Sticky first column: both header AND body */
.hier-table table thead tr th:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 20 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.09);
  min-width: 200px;
}

/* sticky-first is applied via :class on td */
.hier-table .sticky-first {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  min-width: 200px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.09);
  white-space: nowrap;
  padding: 8px 14px !important;
}

/* Body cells */
.hier-table table tbody tr td {
  padding: 8px 14px !important;
  white-space: nowrap;
  font-size: 13.5px;
  border-bottom: 1px solid rgba(102, 126, 234, 0.1) !important;
  background: #fff;
}
.v-theme--dark .hier-table table tbody tr td {
  background: #1a2235;
  border-color: rgba(255, 255, 255, 0.06) !important;
  color: #e0e0e0;
}

/* hover */
.hier-table table tbody tr:hover td {
  background: rgba(67, 97, 238, 0.05) !important;
}
.v-theme--dark .hier-table table tbody tr:hover td {
  background: rgba(67, 97, 238, 0.12) !important;
}

/* Sticky footer */
.hier-table table tfoot {
  position: sticky !important;
  bottom: 0 !important;
  z-index: 10 !important;
}
.hier-table table tfoot tr td {
  background: #e8ecff !important;
  font-weight: 800;
  border-top: 2px solid rgba(102, 126, 234, 0.3) !important;
  padding: 9px 14px !important;
  white-space: nowrap;
}
.v-theme--dark .hier-table table tfoot tr td {
  background: #1e2a40 !important;
  color: #e0e0e0;
}
.grand-first {
  position: sticky !important;
  left: 0 !important;
  z-index: 15 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.09);
}

/* Row type colours */
.hier-table .tr-tl td {
  background: rgba(67, 97, 238, 0.07) !important;
  font-weight: 700;
}
.v-theme--dark .hier-table .tr-tl td {
  background: rgba(67, 97, 238, 0.2) !important;
}

.hier-table .tr-cl td {
  background: rgba(76, 201, 240, 0.06) !important;
  font-weight: 600;
}
.v-theme--dark .hier-table .tr-cl td {
  background: rgba(76, 201, 240, 0.1) !important;
}

.hier-table .tr-client td {
  background: rgba(76, 201, 240, 0.06) !important;
  font-weight: 600;
}
.v-theme--dark .hier-table .tr-client td {
  background: rgba(76, 201, 240, 0.1) !important;
}

.hier-table .tr-ag-even td {
  background: rgba(102, 126, 234, 0.04) !important;
}
.v-theme--dark .hier-table .tr-ag-even td {
  background: rgba(102, 126, 234, 0.08) !important;
}

.hier-table .tr-month td {
  background: rgba(67, 97, 238, 0.1) !important;
  font-weight: 700;
}
.v-theme--dark .hier-table .tr-month td {
  background: rgba(67, 97, 238, 0.18) !important;
}

.hier-table .tr-day td {
  background: #fff;
}
.v-theme--dark .hier-table .tr-day td {
  background: #1a2235;
}

/* Indentation */
.pl-indent-1 {
  padding-left: 28px !important;
}
.pl-indent-2 {
  padding-left: 48px !important;
}

/* Numeric & Drilldown cells */
.num-cell {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
}
.fw-600 {
  font-weight: 600;
}

.drill-link {
  color: #4361ee;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.v-theme--dark .drill-link {
  color: #7eb3ff;
}
.drill-link:hover {
  opacity: 0.75;
}

/* Custom scrollbar */
.hier-table .v-table__wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.hier-table .v-table__wrapper::-webkit-scrollbar-thumb {
  background: rgba(102, 126, 234, 0.4);
  border-radius: 4px;
}
.hier-table .v-table__wrapper::-webkit-scrollbar-track {
  background: transparent;
}

/* MODAL v-data-table */
.modal-vdt table thead tr th {
  background: #f1f3ff !important;
  font-weight: 700 !important;
  white-space: nowrap;
  font-size: 12.5px !important;
}
.v-theme--dark .modal-vdt table thead tr th {
  background: #1e2a40 !important;
  color: #e0e0e0 !important;
}
.modal-vdt table tbody tr td {
  white-space: nowrap;
  font-size: 13px;
}
.modal-vdt table tbody tr:hover td {
  background: rgba(67, 97, 238, 0.05) !important;
}
.v-theme--dark .modal-vdt table tbody tr:hover td {
  background: rgba(67, 97, 238, 0.12) !important;
}

@media (max-width: 768px) {
  .tab-section-title {
    font-size: 15px;
  }
  .hier-table table tbody tr td {
    font-size: 12px;
  }
}
</style>
